import React, { useState, useEffect } from 'react';
import { getUserInfos } from '../services/auth';

const Debug = () => {
    const [storage, setStorage] = useState({});
    const [now, setNow] = useState(Date.now());

    const refreshStorage = () => {
        const allStorage = {};
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            try {
                allStorage[key] = JSON.parse(localStorage.getItem(key));
            } catch (e) {
                allStorage[key] = localStorage.getItem(key);
            }
        }
        setStorage(allStorage);
        setNow(Date.now());
    };

    useEffect(() => {
        refreshStorage();

        const handleStorageChange = () => {
            refreshStorage();
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text ?? '');
        } catch (e) {
            console.error('Copy failed', e);
        }
    };

    const exportStorage = () => {
        const blob = new Blob([JSON.stringify(storage, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `localstorage-${new Date().toISOString()}.json`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const clearAll = () => {
        if (!window.confirm('Supprimer tout le localStorage ?')) return;
        localStorage.clear();
        refreshStorage();
    };

    const currentUser = getUserInfos();

    return (
        <div style={{
            padding: '1rem',
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: 8,
            margin: '1rem',
            boxShadow: '0 6px 18px rgba(0,0,0,0.06)'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                    <h2 style={{ margin: 0, fontSize: 18 }}>Debug · Local Storage</h2>
                    <div style={{ fontSize: 12, color: '#666' }}>Dernière mise à jour : {new Date(now).toLocaleString()}</div>
                </div>

                <div style={{ display: 'flex', gap: 8 }}>
                    {/* <button onClick={refreshStorage} style={{ padding: '6px 10px', cursor: 'pointer' }}>Rafraîchir</button> */}
                    <button onClick={() => copyToClipboard(JSON.stringify(storage, null, 2))} style={{ padding: '6px 10px', cursor: 'pointer' }}>Copier</button>
                    <button onClick={exportStorage} style={{ padding: '6px 10px', cursor: 'pointer' }}>Exporter</button>
                    <button onClick={clearAll} style={{ padding: '6px 10px', cursor: 'pointer', background: '#ffecec' }}>Vider</button>
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 360px', gap: 12 }}>
                <div style={{ background: '#fafafa', padding: 12, borderRadius: 6, border: '1px solid #f0f0f0', maxHeight: '60vh', overflow: 'auto' }}>
                    {Object.keys(storage).length === 0 ? (
                        <div style={{ color: '#666' }}>Aucune donnée dans le localStorage.</div>
                    ) : (
                        Object.entries(storage).sort().map(([key, value]) => (
                            <details key={key} style={{ marginBottom: 10, padding: 8, borderRadius: 6, background: '#fff', border: '1px solid #eee' }}>
                                <summary style={{ fontWeight: 600, cursor: 'pointer', outline: 'none' }}>
                                    {key}
                                </summary>
                                <pre style={{ marginTop: 8, whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: 13 }}>
                                    {typeof value === 'string' ? value : JSON.stringify(value, null, 2)}
                                </pre>
                                <div style={{ marginTop: 8, display: 'flex', gap: 8 }}>
                                    <button onClick={() => copyToClipboard(typeof value === 'string' ? value : JSON.stringify(value, null, 2))} style={{ padding: '6px 8px' }}>Copier</button>
                                    <button onClick={() => { localStorage.removeItem(key); refreshStorage(); }} style={{ padding: '6px 8px' }}>Supprimer</button>
                                </div>
                            </details>
                        ))
                    )}
                </div>

                <aside style={{ background: '#fff', padding: 12, borderRadius: 6, border: '1px solid #eee', height: '100%' }}>
                    <h3 style={{ marginTop: 0, fontSize: 16 }}>Utilisateur connecté</h3>
                    {currentUser ? (
                        <div>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>Name: <strong>{currentUser.username}</strong></div>
                            <div style={{ fontSize: 12, color: '#666', marginBottom: 8 }}>Roles: <strong>{JSON.parse(currentUser.roles).join(', ')}</strong></div>
                        </div>
                    ) : (
                        <div style={{ color: '#666' }}>Aucun utilisateur trouvé dans le localStorage.</div>
                    )}

                    <div style={{ marginTop: 16 }}>
                        <h4 style={{ margin: '8px 0' }}>Résumé</h4>
                        <div style={{ fontSize: 13, color: '#444' }}>
                            Clés stockées : <strong>{Object.keys(storage).length}</strong>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default Debug;
